export const FLASH_ERROR = 'error';
export const FLASH_SUCCESS = 'success';
export const FLASH_WARNING = 'warning';

export const FLASH_MOUNT = 100;
export const FLASH_TRANSITION = 250;
export const FLASH_TTL = 12000;
